// Score Explanation Modal - Simplified
import { X, Info } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ScoreExplanationModal({ isOpen, onClose, scoreType, currentScore }) {
  if (!isOpen) return null;
  
  const titles = {
    spatial_efficiency: "Spatial Efficiency",
    unlockability: "Unlockability", 
    market_alignment: "Market Alignment"
  };
  
  const descriptions = {
    spatial_efficiency: "Measures how effectively your property uses its available space.",
    unlockability: "Indicates the potential for value-adding modifications.",
    market_alignment: "Shows how your property compares to local market trends."
  };
  
  const title = titles[scoreType] || "Score";
  const desc = descriptions[scoreType] || "Score explanation";
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-6">
        <button onClick={onClose} className="absolute top-4 right-4 p-2">
          <X className="w-5 h-5" />
        </button>
        
        <h2 className="text-xl font-bold mb-2">{title}</h2>
        <p className="text-2xl font-bold text-cipher-green mb-4">{currentScore}/100</p>
        <p className="text-gray-600 dark:text-gray-300 mb-6">{desc}</p>
        
        <Button onClick={onClose} className="w-full bg-cipher-green text-white">
          Got it
        </Button>
      </div>
    </div>
  );
}

export default ScoreExplanationModal;
